// design libs
import { Button, Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import "./NewUser.css";

// react libs
import { useContext, useEffect } from "react";
import { UserContext } from "../../context/UserContext";
import { useNavigate, useParams } from "react-router-dom";

// firebase libs
import { db } from "../../firebase/Firebase";
import { doc, setDoc } from "firebase/firestore";

function EditUser() {
    // redirects
    const navigate = useNavigate();

    // get user id
    const params = useParams();

    // methods to call API and to check auth
    const { getEditingUser, editingUser, setEditingUser, updateUser, isLoggedIn, userId } = useContext(UserContext);

    useEffect(() => {
        // if user is not logged in, redirect
        isLoggedIn();
        if (userId === null) {
            console.log("user not logged in");
            navigate("/login");
        }

        // if user is not Admin, redirect
        const role = localStorage.getItem("user_role");
        if (role !== "admin") {
            navigate("/");
        }

        // Proceed
        if(params.id){
            console.log("mi id", params.id);
            getEditingUser(params.id);
        }
        else{
            navigate("/");
        }
    }, []);

    // form handlers
    const handleSubmit = async (e) => {
        e.preventDefault();

        if(editingUser.user_role === "employee" && editingUser.area.length === 0){
            alert("Debe llenar el campo Area/Departamento del trabajador");
            return;
        }
        if(editingUser.user_role === "student" || editingUser.user_role === "admin"){
            editingUser.area = null;
        }
        
        const response = await updateUser(params.id);
        console.log("trying update...", response);
        if(response.ok) {
            console.log("updated correctly");

            // register on firestore
            try{
                const docRef = doc(db, "users/" + editingUser.mail);
                await setDoc(docRef, {
                    user_id: params.id,
                    mail: editingUser.mail,
                    firstname: editingUser.firstname,
                    lastname: editingUser.lastname,
                    user_role: editingUser.user_role,
                    area: editingUser.area
                });
                navigate("/users");
            }
            catch(e){
                console.error("Error en registro remoto (Firestore)");
                console.error(e);
            }
        }
        else{
            console.error("Error en registro local (Postgres)");
            alert("Error al actualizar el usuario!");
            return;
        }
    }

    const handleInputChange = (e) => {
        setEditingUser({ ...editingUser, [e.target.name]: e.target.value });
    }

    const handleCancelButtonClick = () => {
        navigate("/users");
    }

    return (
        <>
            <h2>Editar usuario</h2>
            <Grid container direction="column" alignItems="center" justifyContent="center">
                <Grid item xs={3}>
                    <Card className="card" sx={{ mt: 5 }}>
                        <CardContent className="card-content">
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={6} className="item-form">
                                        <TextField variant="filled" fullWidth sx={{ display: "block", margin: ".5rem 0" }}
                                            onChange={handleInputChange} inputProps={{ style: { color: "white" } }} InputLabelProps={{ style: { color: "white" } }}
                                            label="Nombre" name="firstname" value={editingUser.firstname} required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} className="item-form">
                                        <TextField variant="filled" fullWidth sx={{ display: "block", margin: ".5rem 0" }}
                                            onChange={handleInputChange} inputProps={{ style: { color: "white" } }} InputLabelProps={{ style: { color: "white" } }}
                                            label="Apellido" name="lastname" value={editingUser.lastname} required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} className="item-form">
                                        <TextField variant="filled" fullWidth sx={{ display: "block", margin: ".5rem 0" }}
                                            onChange={handleInputChange} inputProps={{ style: { color: "white" } }} InputLabelProps={{ style: { color: "white" } }}
                                            label="Correo" name="mail" value={editingUser.mail} required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} className="item-form">
                                        <FormControl fullWidth>
                                        <InputLabel id="role-input" style={{color: "white"}}>Rol</InputLabel>
                                        <Select variant="filled" sx={{ display: "block", margin: ".5rem 0", color: "white" }}
                                            onChange={handleInputChange} inputProps={{ style: { color: "white" } }} 
                                            labelId="role-input" required
                                            name="user_role" value={editingUser.user_role}
                                        >
                                            <MenuItem value={"admin"}>Administrador</MenuItem>
                                            <MenuItem value={"employee"}>Trabajador</MenuItem>
                                            <MenuItem value={"student"}>Estudiante</MenuItem>
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} className="item-form">
                                        <TextField variant="filled" fullWidth sx={{ display: "block", margin: ".5rem 0" }}
                                            onChange={handleInputChange} inputProps={{ style: { color: "white" } }} InputLabelProps={{ style: { color: "white" } }}
                                            label="Departamento/Area (vacio si no es trabajador)" name="area" value={editingUser.area || ""}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} className="item-form"><hr /></Grid>

                                    <Grid item xs={12} sm={12} md={12}>
                                        <Grid container spacing={1} alignItems="center" justifyContent="right">
                                            <Grid item>
                                                <Button variant="contained" color="primary" type="submit" className="button">
                                                    Crear
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button variant="contained" color="error" className="button" onClick={handleCancelButtonClick} style={{padding: "8% 60%"}}>
                                                    Cancelar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    );
}

export default EditUser;